import { useEffect } from 'react';
import { useWaitlistStore } from '../lib/store';
import { getTierInfo } from '../lib/tiers';

export function useWaitlistCount() {
  const {
    count,
    loading,
    error,
    isAnimating,
    fetchCount,
    subscribeToChanges,
    unsubscribeFromChanges
  } = useWaitlistStore();

  useEffect(() => {
    fetchCount();
    subscribeToChanges();

    return () => {
      unsubscribeFromChanges();
    };
  }, [fetchCount, subscribeToChanges, unsubscribeFromChanges]);

  return {
    count,
    loading,
    error,
    isAnimating,
    ...getTierInfo(count)
  };
}
